import { render, staticRenderFns } from "./EditMenuModal.vue?vue&type=template&id=67a24509&scoped=true&"
import script from "./EditMenuModal.vue?vue&type=script&lang=js&"
export * from "./EditMenuModal.vue?vue&type=script&lang=js&"
import style0 from "./EditMenuModal.vue?vue&type=style&index=0&id=67a24509&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a24509",
  null
  
)

export default component.exports